import type { IModuleDefinition, IModuleStrings, IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { groupByFor } from '@platform/core/lib/viewSettings';
import { viewsOf } from './patchViews';

/**
 * «Визначення JSON» конструктора (прототип v4 bJson): ключ, назви мовою інтерфейсу, префікс, рівень «workspace», базовий модуль, опис,
 * поля (ключ, підпис, тип, обов'язкове, у списку, варіанти поля вибору), подання (увімкнені, типове, групування беклогу), вкладки форми,
 * і перевизначення простору (ADR-023), якщо воно є. Чиста функція.
 */
export function builderJson(module: IModuleDefinition, rt: IRecordTypeDefinition, patch: IRecordTypeOverride, strings: IModuleStrings): unknown {
  const { enabled, custom, def } = viewsOf(rt, patch);
  const tabs = (rt.forms?.full ?? rt.form).tabs.filter((tab) => ['general', 'related', 'history'].includes(tab));
  return {
    key: rt.key, name: strings.entity(rt.key, 'name', rt.name), singular: strings.entity(rt.key, 'singular', rt.singular ?? null), prefix: rt.prefix,
    scope: 'workspace', core: module.module.core, description: strings.entity(rt.key, 'description', rt.description ?? null) || strings.tagline(module.module.tagline),
    fields: rt.fields.filter((f) => !f.hidden).map((f) => ({
      key: f.key, label: strings.field(rt.key, f.key, f.label), type: f.type, required: !!f.required, inList: !!f.inList,
      ...(f.type === 'select' && f.options?.length ? { options: f.options.map((o) => strings.option(rt.key, f.key, o.value, o.label ?? null)) } : {}),
    })),
    views: { enabled: [...enabled, ...custom], default: def, backlogGroupBy: groupByFor(rt) },
    form: { tabs },
    ...(Object.keys(patch).length ? { override: patch } : {}),
  };
}
